var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F6E7F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6364 11.0909C19.6364 13.3466 17.8012 15.1818 15.5455 15.1818C13.2897 15.1818 11.4545 13.3466 11.4545 11.0909C11.4545 8.83518 13.2897 7 15.5455 7C17.8012 7 19.6364 8.83518 19.6364 11.0909ZM22.0909 23.3636V20.3642C22.0909 17.9579 19.8892 16 17.1818 16H13.9091C11.2017 16 9 17.9579 9 20.3642V23.3636V24.1818V25H22.0909V24.1818V23.3636Z",
    fill: "#A614B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileDefault);
export default __webpack_public_path__ + "static/media/profile-default.591d9ea9e8e249822bd3400da490c1af.svg";
export { ForwardRef as ReactComponent };